import React from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaMobileAlt,
  FaMoneyBill,
  FaRegBuilding,
  FaRegUser,
} from "react-icons/fa";
import BootstrapTable from "src/components/BootstrapTable";
import Title from "src/components/Title";
import TableFormatter from "../utils/tableFormatter";

const AdminSite = () => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Administration</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs defaultActiveKey="users" id="admin-tabs">
            <Tab
              eventKey="users"
              title={
                <>
                  <FaRegUser /> Benutzer
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/users"
                sort="created_at"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "email",
                    name: "E-Mail",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "first_name",
                    name: "Vorname",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name",
                    name: "Nachname",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "email_verified_at",
                    name: "E-Mail verifiziert am",
                    sortable: true,
                    filterControl: "input",
                    formatter: TableFormatter.formatDateTime,
                  },
                  {
                    field: "locale",
                    name: "Sprache",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "is_admin",
                    name: "Administrator",
                    sortable: true,
                    filterControl: "input",
                    formatter: TableFormatter.formatBoolean,
                  },

                  {
                    field: "created_at",
                    name: "Erstellt am",
                    sortable: true,
                    filterControl: "input",
                    formatter: TableFormatter.formatDateTime,
                  },
                ]}
              />
            </Tab>
            <Tab
              eventKey="organisations"
              title={
                <>
                  <FaRegBuilding /> Organisationen
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/organisations"
                sort="created_at"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "created_at",
                    name: "Erstellt am",
                    sortable: true,
                    filterControl: "input",
                    formatter: TableFormatter.formatDateTime,
                  },
                ]}
              />
            </Tab>
            <Tab
              eventKey="devices"
              title={
                <>
                  <FaMobileAlt /> Geräte
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/devices"
                sort="created_at"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "platform",
                    name: "Plattform",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "appVersion",
                    name: "App Version",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "appBuild",
                    name: "App Build",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "hardware",
                    name: "Hardware",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "model",
                    name: "Modell",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "os",
                    name: "Betriebssystem",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "osVersion",
                    name: "Betriebssystem Version",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "language",
                    name: "Sprache",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "created_at",
                    name: "Erstellt am",
                    sortable: true,
                    filterControl: "input",
                    formatter: TableFormatter.formatDateTime,
                  },
                ]}
              />
            </Tab>
            <Tab
              eventKey="postcodes"
              title={
                <>
                  <FaMapMarkerAlt /> Orte
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/postcodes"
                sort="plz"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "plz",
                    name: "PLZ",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name_de",
                    name: "Name (DE)",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name_fr",
                    name: "Name (FR)",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name_it",
                    name: "Name (IT)",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "latitude",
                    name: "Breitengrad",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "longitude",
                    name: "Längengrad",
                    sortable: true,
                    filterControl: "input",
                  },
                ]}
              />
            </Tab>
            <Tab
              eventKey="plans"
              title={
                <>
                  <FaMoneyBill /> Subscription Pläne
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/plans"
                sort="plz"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name",
                    name: "Name",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "description",
                    name: "Beschreibung",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "price_per_duration",
                    name: "Preis pro Dauer",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "duration_in_day",
                    name: "Dauer in Tagen",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "max_image_count",
                    name: "Maximale Bildanzahl",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "max_tags_count",
                    name: "Maximale Tag-Anzahl",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "max_tags_featured_count",
                    name: "Maximale hervorgehobene Tag-Anzahl",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "max_description_length",
                    name: "Maximale Beschreibungslänge",
                    sortable: true,
                    filterControl: "input",
                  },
                ]}
              />
            </Tab>
            <Tab
              eventKey="boostplans"
              title={
                <>
                  <FaMoneyBill /> Boost Pläne
                </>
              }
            >
              <BootstrapTable
                url="/api/backend/admin/boostplans"
                sort="plz"
                order="desc"
                showSearch
                showClear
                showRefresh
                showFilter
                cache
                pageSize={25}
                pageSizes={[25, 50, 100, 250]}
                columns={[
                  {
                    field: "id",
                    name: "ID",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "name",
                    name: "Name",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "description",
                    name: "Beschreibung",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "price_per_duration",
                    name: "Preis pro Dauer",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "duration_in_day",
                    name: "Dauer in Tagen",
                    sortable: true,
                    filterControl: "input",
                  },
                  {
                    field: "duration_in_day",
                    name: "Dauer in Tagen",
                    sortable: true,
                    filterControl: "input",
                  },
                ]}
              />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AdminSite;
